import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../components/bootstrap/Button';
import { useMst } from '../../../../models';
import AlarmService from '../../../../services/AlarmService';
import moment from 'moment';
import { Base64 } from 'js-base64';
import { useCallback } from 'react';
// // import 'moment/locale/ko';

const NotificationList = observer(({ toggleNotification, }) => {
	const { t } = useTranslation();
	const tr = useCallback((name) => t(`notification.${name}`), [t]);
	const { user, company, notifiction } = useMst();
	const navigate = useNavigate();

	const _readAlarm = async (alarm, index) => {
		if (!alarm.read) {
		  await AlarmService.alarmRead({ids: [alarm.id]}).then(() => {
			  notifiction.getRefresh(company.get.id);

		  });
		}
	  };

	return (
		<>
			{notifiction?.get?.list?.map((notis) => {

				const noti = {
					...notis,
					data: JSON.parse(notis.data)
				};

				return (
					<Button
						key={noti.id}
						type='button'

						className={`w-100 py-3 text-start border-bottom border-1 text-info`}
						onClick={() => {

							if(!noti.read)
								_readAlarm(noti, noti.id);

							if(noti?.data?.detailId) {
								const cryptoUrl = Base64.encode(`${company.get.id}_${noti?.data?.detailId}`);
								toggleNotification(false);
								// navigate(`/e-approval/document/${cryptoUrl}`);
								window.location.href = `/e-approval/document/${cryptoUrl}`;
							}
						}}
						rounded={0}
					>
						<div className='d-flex justify-content-between'>
							<span className={`${noti.read ? 'text-dark' : 'text-info'}`} style={{ opacity: noti.read ? 0.3 : 1}}>[{t((noti.data.title || noti.title), noti.data)}]</span>
							<span className={`fw-light ${noti.read ? 'text-dark' : 'text-muted'}`} style={{ opacity: noti.read ? 0.3 : 1}}>{moment(noti?.createdAt).format('YYYY-MM-DD')}</span>

						</div>
						<div className={`ms-2 mt-2 fw-normal ${noti.read ? 'text-dark' : ''}`} style={{ opacity: noti.read ? 0.3 : 1}}>
							{t((noti.data.message || noti.message), noti.data)}
						</div>
					</Button>
				);
			})}

			{notifiction?.get?.list?.length === 0 && (
				<div className='lead text-center py-5'>{t('notification.noNoti')}</div>
			)}
		</>
	);
});
export default NotificationList;